import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import App from "./App";

// 1) Create a default (or custom) MUI theme
const theme = createTheme({
  // Optionally override defaults here
  // e.g. palette: { primary: { main: "#1976d2", dark: "#115293" }, ... }
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// 2) Wrap <App /> in <ThemeProvider> so that MUI’s useTheme() or styled()
//    calls have access to `theme`.
root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);
